import React from 'react';
import { ComponentExt } from '@utils/reactExt';
import * as styles from './style/index.scss'; // 假设有样式
import { InputItem, Button } from 'antd-mobile';
import { inject, observer } from 'mobx-react';
import { PATTERN } from '@constants/validate';
import { Redirect, withRouter } from 'react-router-dom';
import { deepClone } from '@src/utils';
import { IUserStore } from '@store/store';
import PageLoadingC from '@components/pageLoading';
import _ from 'lodash';
import { encrypt } from '@utils/aes.js';
// 导入图片根据图1
// import CaptchaImg from '@assets/img/captcha.png'; 等
import { LoginStore } from '@views/login/store'; // 假设复用原有 store
// import Logo from '@assets/img/lenovo-logo.png'; // 移除以修复模块找不到错误

interface LoginProps {
    userStore: IUserStore;
    loginStore: LoginStore;
    location?: any;
    history: any; // 或 import { History } from 'history';
}

interface LoginState {
    email: string;
    captcha: string;
    verification: string;
    password: string;
    passwordAgain: string;
    // 错误状态等
}

class Login extends ComponentExt<LoginProps, LoginState> {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            captcha: '',
            verification: '',
            password: '',
            passwordAgain: '',
        };
        // 添加登录逻辑
    }

    handleInputChange = (field: keyof LoginState, value: string) => {
        this.setState({ [field]: value } as Pick<LoginState, keyof LoginState>);
    };


    handleRegister = () => {
        const { email, captcha, verification, password, passwordAgain } = this.state;
        if (password !== passwordAgain) {
            // 显示错误，例如使用toast
            return;
        }
        // 模拟成功注册，直接跳转
        this.props.history.push('/esim/main');
    };

    render() {
        const { email, captcha, verification, password, passwordAgain } = this.state;
        // // 假设用户已登录 redirect
        // if (this.props.userStore.userInfo) {
        //     return <Redirect to='/esim/main' />;
        // }
        return (
            <section className={styles.login}>
                {/* <img src={Logo} alt="Logo" className={styles.logo} /> */}
                <h2>Sign up</h2>
                <InputItem
                    placeholder="Email address"
                    value={email}
                    onChange={(v) => this.handleInputChange('email', v)}
                >Email</InputItem>
                <InputItem
                    placeholder="Captcha Text"
                    value={captcha}
                    onChange={(v) => this.handleInputChange('captcha', v)}
                >Captcha Text</InputItem>
                <InputItem
                    placeholder="Verification code"
                    value={verification}
                    onChange={(v) => this.handleInputChange('verification', v)}
                >Verification code</InputItem>
                <InputItem
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={(v) => this.handleInputChange('password', v)}
                >Password</InputItem>
                <InputItem
                    type="password"
                    placeholder="Password again"
                    value={passwordAgain}
                    onChange={(v) => this.handleInputChange('passwordAgain', v)}
                >Password again</InputItem>
                <Button type="primary" onClick={this.handleRegister}>Sign up</Button>
                <p>Terms of Use and Privacy Policy</p>
            </section>
        );
    }
}

export default withRouter(inject('userStore', 'loginStore')(observer(Login)));
